"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWaterTapHighOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M17 14h9v-2h-9a2 2 0 00-2 2v2h-4v-4.3A3.7 3.7 0 0114.69 8H26V6h-5V3h3V1h-8v2h3v3h-4.31A5.7 5.7 0 009 11.7V18h8zM25.83 26l-.62.79A3.53 3.53 0 0122.67 28a3.61 3.61 0 01-2.55-1.22l-.76-.94-.79.92A3.65 3.65 0 0116.24 28C14.09 28 14 25.3 14 25v-5h-2v5c0 .31-.1 3-2.67 3a3.68 3.68 0 01-2.55-1.22L6.16 26 4.6 27.25l.62.78a5.63 5.63 0 004.11 2A4.24 4.24 0 0013 28.28 3.76 3.76 0 0016.24 30a5.06 5.06 0 003.09-1.22A5.37 5.37 0 0022.67 30a5.54 5.54 0 004.12-2l.61-.79z" })));
}
exports.default = SvgWaterTapHighOutline;
//# sourceMappingURL=WaterTapHighOutline.js.map